import React, { useEffect, useState } from 'react';
import SideNavbar from './helpers/SideNavbar';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faImage } from '@fortawesome/free-solid-svg-icons';


const UpdatePendingPostDropdown = () => {
    const { ContentId } = useParams();
    const UserID = localStorage.getItem("UserID");
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [updatedContent, setUpdatedContent] = useState('');
    const [selectedPrompt, setSelectedPrompt] = useState('');
    const [promptData, setPromptData] = useState([]);
    const [isUpdating, setIsUpdating] = useState(false);
    const [image, setImage] = useState(null);
    const [selectedImagename, setSelectedImagename] = useState('');
    const [fetchedImages, setFetchedImages] = useState([]);


    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallgeneratedpostsbyContentId/${ContentId}`);
                setPosts(response.data);
                if (response.data.length > 0) {
                    setUpdatedContent(response.data[0].Content);
                    setSelectedPrompt(response.data[0].Prompts);
                    // setImage(response.data[0]?.image)
                    setSelectedImagename(response.data[0]?.image)
                }
                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch posts:', err.message);
                setError('Failed to fetch posts');
                setLoading(false);
            }
        };

        const fetchPrompts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getprompts/${UserID}`);
                if (response.status === 200 && response.data) {
                    setPromptData(response.data.map(prompt => ({
                        id: prompt.PromptID,
                        text: prompt.PromptData
                    })));
                }
            } catch (error) {
                console.error('Error fetching prompts:', error);
            }
        };

        fetchPosts();
        fetchPrompts();
    }, [UserID, ContentId]);


    const handlePromptChange = async (e) => {
        const newPrompt = e.target.value;
        setSelectedPrompt(newPrompt);
        setLoading(true)
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/generateAIContentinUpdatepost`, { UserID, Prompts: newPrompt });
            setLoading(false)
            if (response.status === 200 && response.data) {
                setUpdatedContent(response.data.content);
            }
        } catch (err) {
            console.error('Failed to generate content:', err.message);
            setError('Failed to generate content');
        }
    };
    useEffect(() => {
        if (updatedContent?.trim()) {
            const hashtags = updatedContent.match(/#[\w]+/g) || [];
            fetchImagesForTags(hashtags.slice(-5));
        }
    }, [updatedContent]);

    const validateImage = async (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = url;
            img.onload = () => resolve(url);
            img.onerror = () => resolve(null);
        });
    };

    const fetchImagesForTags = async (tags) => {
        if (!tags.length) return;

        try {
            const query = tags.join(" ");
            const response = await axios.get("https://www.googleapis.com/customsearch/v1", {
                params: {
                    key: process.env.REACT_APP_GOOGLE_API_KEY,
                    cx: process.env.REACT_APP_GOOGLE_CSE_ID,
                    q: query,
                    searchType: "image",
                    num: 10,
                    rights: 'cc_publicdomain,cc_attribute',
                    safe: 'active',
                },
            });

            if (response.data.items) {
                const imageLinks = await Promise.all(response.data.items.map((item) => validateImage(item.link)));
                const validImages = imageLinks.filter((link) => link !== null);

                if (validImages.length === 0) {
                    setFetchedImages([]); // Ensure state is empty
                } else {
                    setFetchedImages(validImages);
                }
            } else {
                setFetchedImages([]);
            }
        } catch (error) {
            console.error("Error fetching images:", error);
            setFetchedImages([]);
        }
    };
    const [selectedImageUrl, setSelectedImageUrl] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isMaximized, setIsMaximized] = useState(false);

    const handleSelectSuggestedImage = (imageUrl) => {
        setSelectedImageUrl(imageUrl);
        setImage(null);
        // setSelectedImagename(imageUrl);
        setIsModalOpen(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const maxSize = 50 * 1024 * 1024; // 50 MB in bytes

        if (file && file.size > maxSize) {
            Swal.fire({
                icon: 'error',
                title: 'File Size Exceeded',
                text: 'The file size should not exceed 50 MB.',
                showConfirmButton: true,
            });
            setImage(null);
            setSelectedImagename('');
        } else {
            setImage(file);
            setSelectedImagename(file.name);
        }
    };


    const handleSaveUpdate = async () => {
        if (!updatedContent) return;

        setLoading(true);
        const formData = new FormData();
        formData.append('ContentId', ContentId);
        formData.append('UserID', UserID);
        formData.append('Content', updatedContent);
        formData.append('Prompts', selectedPrompt);

        if (image) {
            formData.append('image', image); // Upload directly if it's a file
        } else if (selectedImageUrl) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/download-image?url=${encodeURIComponent(selectedImageUrl)}`);  // Fetch the image from URL
                const blob = await response.blob();  // Convert to Blob
                const fileName = `image_${Date.now()}.jpg`; // Generate a filename
                const file = new File([blob], fileName, { type: blob.type }); // Create a File object

                formData.append('image', file); // Append the file to FormData
            } catch (error) {
                console.error("Error downloading image:", error);
                setLoading(false);
                return;
            }
        } else {
            formData.append('image', selectedImagename || '');
        }

        try {
            const resp = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/updateContent`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            setLoading(false);

            if (resp.data.message === 'Post updated successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Post updated successfully',
                    showConfirmButton: false,
                    timer: 3000
                });

                setPosts(posts.map(post => post.ContentId === ContentId ?
                    { ...post, Content: updatedContent, image: selectedImageUrl || image } : post
                ));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error updating post!',
                    showConfirmButton: false,
                    timer: 3000
                });
            }

            setIsUpdating(false);
        } catch (err) {
            console.error('Failed to update post:', err.message);
            setError('Failed to update post');
        }
    };

    return (
        <SideNavbar>
            <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                <div className="card-header d-flex justify-content-between" style={{ border: 'none', backgroundColor: '#fff' }}>

                    <div className=''>
                        <Link to="/viewallpendingposts">
                            <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}><i class="fa fa-arrow-left" style={{ marginRight: '30px' }} aria-hidden="true"></i>Update Post</h5>
                        </Link></div>
                    <div>
                    </div>

                </div>
                <hr />
                {loading ? <div className='spinner'></div> :
                    <div className='container'>
                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Prompt</Tooltip>)}>
                            <div className='form-group'>
                                <label htmlFor='promptSelect'>Prompt:</label>
                                <select
                                    id='promptSelect'
                                    value={selectedPrompt}
                                    onChange={handlePromptChange}
                                    className='form-control'
                                >
                                    {promptData.map(prompt => (
                                        <option key={prompt.id} value={prompt.text}>
                                            {prompt.text}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </OverlayTrigger>

                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Content</Tooltip>)}>
                            <div className='form-group mt-5'>
                                <textarea
                                    value={updatedContent}
                                    onChange={(e) => {
                                        const content = e.target.value;
                                        if (content.length > 2950) {
                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Content Length Exceeded',
                                                text: 'The content should not exceed 2950 characters.',
                                                showConfirmButton: true,
                                            });
                                        } else {
                                            setUpdatedContent(content);
                                        }
                                    }}
                                    style={{
                                        fontSize: '15px',
                                        borderRadius: '8px',
                                        border: '1px solid #cfeafb',
                                        background: '#FFFFFF',
                                        height: '800px',
                                        width: "100%",
                                        padding: '0px 20px',
                                        fontSize: '16px',
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                        <div className="row" style={{ gap: '4px', marginTop: '12px' }}>
                            {fetchedImages.length > 0 ? (
                                fetchedImages.map((img, index) => (
                                    <div key={index} className="col-4 col-md-3 col-lg-2 col-xl-2">
                                        <div 
                                            className="position-relative"
                                            style={{ 
                                                aspectRatio: "1",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                cursor: "pointer",
                                                border: selectedImageUrl === img ? "2px solid #2e3192" : "1px solid transparent",
                                                transition: "all 0.2s ease",
                                                backgroundColor: "#f7fafc",
                                                maxWidth: "120px"
                                            }}
                                            onMouseEnter={(e) => {
                                                if (selectedImageUrl !== img) {
                                                    e.currentTarget.style.borderColor = "#cbd5e0";
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (selectedImageUrl !== img) {
                                                    e.currentTarget.style.borderColor = "transparent";
                                                }
                                            }}
                                            onClick={() => handleSelectSuggestedImage(img)}
                                        >
                                            <img
                                                src={img}
                                                alt="Suggested"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    display: "block"
                                                }}
                                            />
                                            
                                            {/* Top-right checkbox */}
                                            <div
                                                className="position-absolute"
                                                style={{ 
                                                    top: "6px", 
                                                    right: "6px",
                                                    width: "22px",
                                                    height: "22px",
                                                    borderRadius: "50%",
                                                    backgroundColor: selectedImagename === img ? "#2e3192" : "rgba(255, 255, 255, 0.95)",
                                                    border: selectedImagename === img ? "none" : "2px solid rgba(0, 0, 0, 0.2)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    cursor: "pointer",
                                                    transition: "all 0.15s ease",
                                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)"
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const newChecked = !(selectedImagename === img);
                                                    setSelectedImagename(newChecked ? img : null);
                                                    setSelectedImageUrl(newChecked ? img : null);
                                                }}
                                            >
                                                {selectedImagename === img && (
                                                    <FontAwesomeIcon 
                                                        icon={faCheck} 
                                                        style={{ 
                                                            color: "#fff", 
                                                            fontSize: "10px"
                                                        }} 
                                                    />
                                                )}
                                            </div>
                                            
                                            {/* Bottom action buttons overlay */}
                                            <div
                                                className="position-absolute d-flex gap-2"
                                                style={{
                                                    bottom: "8px",
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    opacity: selectedImageUrl === img ? "1" : "0",
                                                    transition: "opacity 0.2s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.opacity = "1";
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (selectedImageUrl !== img) {
                                                        e.currentTarget.style.opacity = "0";
                                                    }
                                                }}
                                            >
                                                <button
                                                    className="btn btn-sm"
                                                    style={{
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        padding: "0",
                                                        borderRadius: "6px",
                                                        backgroundColor: "rgba(255, 255, 255, 0.95)",
                                                        border: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedImageUrl(img);
                                                        setIsModalOpen(true);
                                                    }}
                                                    title="View Full Image"
                                                >
                                                    <FontAwesomeIcon icon={faImage} style={{ color: "#2e3192", fontSize: "12px" }} />
                                                </button>
                                                
                                                <button
                                                    className="btn btn-sm"
                                                    style={{
                                                        minWidth: "32px",
                                                        height: "32px",
                                                        padding: "0",
                                                        borderRadius: "6px",
                                                        backgroundColor: "#2e3192",
                                                        border: "none",
                                                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setSelectedImagename(img);
                                                        setSelectedImageUrl(img);
                                                    }}
                                                    title="Select This Image"
                                                >
                                                    <FontAwesomeIcon icon={faCheck} style={{ color: "#fff", fontSize: "12px" }} />
                                                </button>
                                            </div>
                                            
                                            {/* Hover overlay */}
                                            {selectedImageUrl !== img && (
                                                <div
                                                    className="position-absolute"
                                                    style={{
                                                        top: 0,
                                                        left: 0,
                                                        right: 0,
                                                        bottom: 0,
                                                        backgroundColor: "rgba(0, 0, 0, 0)",
                                                        transition: "background-color 0.2s ease",
                                                        pointerEvents: "none"
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.05)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0)";
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="m-2">No images found for this post</p>
                            )}
                        </div>

                        {/* Modal for Image Preview */}
                        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} size={isMaximized ? "xl" : "lg"} centered>
                            <Modal.Body className="text-center">
                                <img
                                    src={selectedImageUrl}
                                    alt="Selected"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: isMaximized ? "90vh" : "70vh",
                                        objectFit: "contain",
                                    }}
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
                                    Close
                                </Button>
                                <Button variant="primary" onClick={() => setIsMaximized(!isMaximized)}>
                                    {isMaximized ? "Minimize" : "Maximize"}
                                </Button>
                            </Modal.Footer>
                        </Modal>


                        <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Upload Image/Video</Tooltip>)}>
                            <div className='form-group mt-3 mb-5'>
                                <input
                                    type='file'
                                    onChange={(e) => {
                                        handleImageChange(e); // Keep existing upload handling
                                        setSelectedImageUrl(null); // Clear suggested image selection when a file is chosen
                                    }}
                                    className='form-control'
                                    accept='image/*,video/*'
                                />
                                {selectedImagename && <p>{selectedImagename}</p>}
                            </div>
                        </OverlayTrigger>
                        <button onClick={handleSaveUpdate} className="btn btn-primary mt-3">Update</button>
                    </div>
                }
            </div>
        </SideNavbar>
    );
};

export default UpdatePendingPostDropdown;
